import WorkbenchApp from './workbench/App.js';
import ModelCanvas from './components/ModelCanvas';
/** Public application composition. Feature state remains in WorkbenchApp/Workspace. */
export default function App() {
  return <WorkbenchApp ModelCanvas={ModelCanvas} />;
}
